import { Component, Input, OnInit } from '@angular/core';
import { GdprRequestActionViewModel } from '../../../../core/models/gdpr-request-action-view-model.dto';

@Component({
    selector: 'app-highlight-entity',
    templateUrl: './highlight-entity.component.html',
    styleUrls: ['./highlight-entity.component.scss'],
})
export class HighlightEntityComponent implements OnInit {
    logString: string;

    @Input() entity: GdprRequestActionViewModel;

    ngOnInit() {
        this.logString = this.getLogString(this.entity);
    }

    getLogString(logItem: GdprRequestActionViewModel): string {
        const logString = logItem.actionString.replace(
            /\{(User|Tag|Category):((([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}|(\d+)))\}/gi,
            (fullMatch, entityType, entityId) => {
                return this.getLinkForEntity(logItem, entityType, entityId);
            },
        );
        return logString;
    }

    getLinkForEntity(logItem: GdprRequestActionViewModel, entityType, entityId): string {
        switch (entityType) {
            case 'User': {
                const currentUser = logItem.users.find((user) => {
                    return user.id === entityId;
                });

                if (currentUser) {
                    return currentUser.name || currentUser.email;
                } else {
                    return '';
                }
            }

            default:
                return entityType;
        }
    }
}
